import React, { useContext, useEffect, useState } from "react";
import { Api } from "../../../providers";
import { ServiceContext } from "./../../../contexts/service";
import { ListTable } from "./listTable";
import qs from "qs";
import ReactPaginate from "react-paginate";
import styles from "./styles.module.scss";
import ResultNotFound from "../../resultNotFound";

const TipoServicoTable = () => {
    const { typeService, setTypeService, loading, setLoading, totalPages,
        setTotalPages, paramsFilter } = useContext(ServiceContext);
    
    let mounted = true;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        Api.get(`/servico-tipo/pagination/0/20`).then((res) => {
            if (mounted) {
                setTypeService(res.data.content);
                setTotalPages(res.data.totalPages);
                setLoading(false);
            }
        }).catch(_ => {
            if (mounted) {
                setLoading(false);
                setTypeService([]);
            }
        });
        return () => {
            mounted = false;            
        };
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [paramsFilter]);

    const nextPage = (page = 0) => {
        setLoading(true);
        const urlData = `/servico-tipo/pagination/${page}/20`;
        const params = paramsFilter;
        Api.get(urlData, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        }).then((res) => {
            setTypeService(res.data.content);
            setTotalPages(res.data.totalPages);
            setLoading(false);
        }).catch(_ => {
            setLoading(false);
        });
    }
    const currentItems = typeService;
    const pageCountData = totalPages;

    const handlePageClick = (event) => {
        const total = parseInt(event.selected) + 1;
        setCurrentPage(total);
        nextPage(event.selected);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center mt-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando</span>
                </div>
            </div>
        );
    }

    return (
        <>
            
            {currentItems.length > 0 && (
                <ListTable currentItems={currentItems} />
            )}

            {currentItems.length <= 0 && (
                <ResultNotFound style={{marginBottom: 10}} />
            )}
            
            <div className={styles.reactPaginate}>
                <ReactPaginate
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCountData}
                    previousLabel="<"
                    nextLabel=">"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName={styles.pagination}
                    pageClassName={styles.pageItem}
                    pageLinkClassName={"page-link"}
                    previousLinkClassName={styles.pageLink}
                    nextClassName={styles.pageItem}
                    nextLinkClassName={styles.pageLink}
                    activeClassName={"active"}
                    forcePage={currentPage - 1}
                    disabledClassName={styles.disabled}
                />
            </div>
        </>
    );
};

export default TipoServicoTable;
